const TabList = require('ffss/ui/TabList');


class DocumentSearch {
    defaultOptions() {
        return {
            '$container': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);
        
        this.$container = this.settings.$container;
        if(!this.$container){
            window.notify("$container is missing in component/row/DocumentSearch ","error");
        }

        this.$form = $('.document-search-form',this.$container);
        this.$filterCategorie = $('select[name="categorie"]',this.$form);
        this.$filterSearch = $('input[name="search"]',this.$form);

        this.initialize();
    }


    initialize(){
        var self = this;

    }

}

module.exports = DocumentSearch;